import { render, staticRenderFns } from "./popular.vue?vue&type=template&id=3d4f20d6&scoped=true"
import script from "./popular.vue?vue&type=script&lang=js"
export * from "./popular.vue?vue&type=script&lang=js"
import style0 from "./popular.vue?vue&type=style&index=0&id=3d4f20d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f20d6",
  null
  
)

export default component.exports